export const DashboardConstant = {
    UPDATE: 'DS_SUCCESS'
};